import { TabProps } from "shared/types";
import { EnumOwnerType, Owner } from "gql/generated.ts";
import { OperatorTabsEnum } from "apps/directory/shared.ts";
import { TFunction } from "i18next";

export const getOperatorTabsConfig = (
  t: TFunction<"translation", undefined>,
  loggedInAs: Owner | null,
) => {
  const operatorTabsConfig: TabProps[] = [
    {
      value: OperatorTabsEnum.BackOffice,
      title: t("directory:OPERATOR.BACK_OFFICE.TITLE"),
    },
    {
      value: OperatorTabsEnum.Profile,
      title: t("directory:OPERATOR.PROFILE.TITLE"),
    },
    {
      value: OperatorTabsEnum.Media,
      title: t("directory:OPERATOR.MEDIA.TITLE"),
    },
    {
      value: OperatorTabsEnum.Staff,
      title: t("core:STAFF.TITLE"),
    },
    // {
    //   value: OperatorTabsEnum.FeaturedIn,
    //   title: t("directory:OPERATOR.FEATURED_IN.TITLE"),
    // },
    {
      value: OperatorTabsEnum.Events,
      title: t("directory:OPERATOR.EVENTS.TITLE"),
    },
    {
      value: OperatorTabsEnum.Activity,
      title: t("directory:OPERATOR.ACTIVITY.TITLE"),
    },
    {
      value: OperatorTabsEnum.Connections,
      title: t("directory:OPERATOR.CONNECTIONS.TITLE"),
    },
  ];

  if (loggedInAs?.type === EnumOwnerType.Operator) {
    return operatorTabsConfig.filter(
      (tabConfig) => tabConfig.value !== OperatorTabsEnum.BackOffice,
    );
  }

  if (loggedInAs?.type === EnumOwnerType.Organization) {
    return operatorTabsConfig.filter(
      (tabConfig) => tabConfig.value !== OperatorTabsEnum.Connections,
    );
  }

  return operatorTabsConfig;
};
